import { render, staticRenderFns } from "./Amendment.vue?vue&type=template&id=2c28da48&scoped=true&"
import script from "./Amendment.vue?vue&type=script&lang=js&"
export * from "./Amendment.vue?vue&type=script&lang=js&"
import style0 from "./Amendment.vue?vue&type=style&index=0&id=2c28da48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28da48",
  null
  
)

export default component.exports